import VariableRole from './VariableRole';
import builtinArgs from './BUILTIN_ARGS';

export default {
	variables: [
		{
			id: 'size',
			role: VariableRole.PARAM,
			unit: 'juice',
			defaultValue: 1200000000,
			showInGui: false
		},
		{
			id: 'daysReceivableImportance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'qualityImportance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'marketingImportance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0.1,
			showInGui: false
		},
		{
			id: 'performance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'price',
			role: VariableRole.DECISION,
			unit: '€/juice',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'pricePerformance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'daysReceivable',
			role: VariableRole.DECISION,
			unit: 'day',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'daysReceivablePerformance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'quality',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 1,
			showInGui: true
		},
		{
			id: 'qualityPerformance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 1,
			showInGui: false
		},
		{
			id: 'marketingExpenses',
			role: VariableRole.DECISION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'marketingPerformance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'deliveredUnits',
			role: VariableRole.EXPRESSION,
			unit: 'juice/year',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'soldUnits',
			role: VariableRole.EXPRESSION,
			unit: 'juice/year',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'demandQuota',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'supposedPrice',
			role: VariableRole.DECISION,
			unit: '€/juice',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'supposedPricePerformance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'supposedMarketingExpenses',
			role: VariableRole.DECISION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'supposedMarketingImportance',
			role: VariableRole.EXPRESSION,
			unit: 'number',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'supposedMarketingPerformance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'supposedDaysReceivableImportance',
			role: VariableRole.EXPRESSION,
			unit: 'number',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'supposedDaysReceivable',
			role: VariableRole.DECISION,
			unit: 'day',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'supposedDaysReceivablePerformance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'supposedQuality',
			role: VariableRole.DECISION,
			unit: 'percentage',
			defaultValue: 1,
			showInGui: true
		},
		{
			id: 'supposedQualityPerformance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 1,
			showInGui: false
		},
		{
			id: 'supposedQualityImportance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'supposedPerformance',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'supposedDemandQuota',
			role: VariableRole.EXPRESSION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'supposedSoldUnits',
			role: VariableRole.EXPRESSION,
			unit: 'juice/year',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'machineryUnitDepreciation',
			role: VariableRole.EXPRESSION,
			unit: '€/machine/year',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'machineryDepreciation',
			role: VariableRole.EXPRESSION,
			unit: '€/year',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'sellingCommissionRate',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 0.02,
			showInGui: false
		},
		{
			id: 'sellingCommissions',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'sellingExpenses',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 3000000,
			showInGui: true
		},
		{
			id: 'revenues',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'directMaterialCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'indirectMaterialCosts',
			role: VariableRole.PARAM,
			unit: '€/machine',
			defaultValue: 300000,
			showInGui: false
		},
		{
			id: 'outsourcedProductionCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'contributionMargin',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'indirectManPowerCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'qualityCheckCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'productionOverheads',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'marketingAndSellingExpenses',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'totalGenaralExpenses',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 4000000,
			showInGui: false
		},
		{
			id: 'generalAndAdministrativeExpenses',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'operatingIncome',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'avarageDailyPurchaseCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'otherAssetsDepreciation',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'productionAssetsDepreciation',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'fixedAssetsDepreciation',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'accumulatedDepreciation',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'interestExpensesLongTerm',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0.3,
			showInGui: true
		},
		{
			id: 'interesetExpensesOnBankOverdraft',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'preTaxIncome',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'preTaxIncomeWithShortTerm',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'taxRate',
			role: VariableRole.PARAM,
			unit: 'perc',
			defaultValue: 0.35,
			showInGui: false
		},
		{
			id: 'taxes',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'netIncome',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'shortTermDebts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
    {
      id: 'shortTermDebtsBalanceSheet',
      role: VariableRole.EXPRESSION,
      unit: '€',
      defaultValue: 0,
      showInGui: true
    },
    {
      id: 'lastYearCash',
      role: VariableRole.EXPRESSION,
      unit: '€',
      defaultValue: 0,
      showInGui: true
    },
		{
			id: 'shortTermDebtsDelta',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'shortTermDebtsOnRevenues',
			role: VariableRole.EXPRESSION,
			unit: '%',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'directMaterialUnitaryCost',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'cashFlowFromOperations',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'financingCashFlow',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'totalCashFlow',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'netFixedAssets',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'avarageDailyOutsourcingCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'machineryDepreciationPeriod',
			role: VariableRole.PARAM,
			unit: 'year',
			defaultValue: 15,
			showInGui: false
		},
		{
			id : 'daysInPayablesApples',
			role : VariableRole.EXPRESSION,
			unit : '€',
			defaultValue : 0,
			showInGui : false
		},
		{
			id : 'daysInPayablesBottles',
			role : VariableRole.EXPRESSION,
			unit : '€',
			defaultValue : 0,
			showInGui : false
		},
		{
			id : 'purchaseCostsApples',
			role : VariableRole.EXPRESSION,
			unit : '€',
			defaultValue : 0,
			showInGui : false
		},
		{
			id : 'purchaseCostsBottles',
			role : VariableRole.EXPRESSION,
			unit : '€',
			defaultValue : 0,
			showInGui : false
		},
		{
			id : 'avarageDailyPurchaseCostsApples',
			role : VariableRole.EXPRESSION,
			unit : '€',
			defaultValue : 0,
			showInGui : false
		},
		{
			id : 'avarageDailyPurchaseCostsBottles',
			role : VariableRole.EXPRESSION,
			unit : '€',
			defaultValue : 0,
			showInGui : false
		},
		{
			id: 'supplierAccountPayables',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'outsourcingAccountPayables',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'offices',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 5400000,
			showInGui: false
		},
		{
			id: 'ITinfrastructures',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 400000,
			showInGui: false
		},
		{
			id: 'AutomobilesVehicles',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 200000,
			showInGui: false
		},
		{
			id: 'investmentOffices',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'investmentITinfrastructures',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'investmentAutomobilesVehicles',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'netOffices',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'netITinfrastructures',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'netAutomobilesVehicles',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'otherAssetsDepreciationPeriod',
			role: VariableRole.PARAM,
			unit: 'year',
			defaultValue: 5,
			showInGui: false
		},
		{
			id: 'totalOtherAssets',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'totalOtherInvestments',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'machineries',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'productionInvestments',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'productionAssets',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'fixedAssets',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'equity',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'debtEquityRatio',
			role: VariableRole.EXPRESSION,
			unit: '',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'leverage',
			role: VariableRole.EXPRESSION,
			unit: '%',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'cccSales',
			role: VariableRole.EXPRESSION,
			unit: '%',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'roi',
			role: VariableRole.EXPRESSION,
			unit: '',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'ros',
			role: VariableRole.EXPRESSION,
			unit: '',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'roe',
			role: VariableRole.EXPRESSION,
			unit: '',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'roa',
			role: VariableRole.EXPRESSION,
			unit: '',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'longTermDebt',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'cash',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'cashGrowthRate',
			role: VariableRole.EXPRESSION,
			unit: '%',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'equityDelta',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'additionalNeedsOfFunds',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'additionalNeedsOfFundsDelta',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'longTermDebtDelta',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'fixedAssetsDelta',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'capitalExpenditures',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'accountPayables',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'accountReceivables',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'finishedGoodsInventory',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'totalRawMaterialInventory',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'longInterestThresholdA',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 0.06,
			showInGui: false
		},
		{
			id: 'longInterestThresholdB',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 0.06,
			showInGui: false
		},
		{
			id: 'longInterestThresholdC',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 0.06,
			showInGui: false
		},
		{
			id: 'rawMaterialInventoryBottles',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'rawMaterialInventoryApples',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'totalCurrentAssets',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'inventory',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'totalAssets',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'currentLiabilities',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'totalLiabilities',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'totalEquity',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'retainedEarnings',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'totalLiabilitiesAndEquity',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'qualityCheckPersonel',
			role: VariableRole.DECISION,
			unit: 'person',
			defaultValue: 1,
			showInGui: true
		},
		{
			id: 'totalManPower',
			role: VariableRole.EXPRESSION,
			unit: 'person',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'machinesPerBuilding',
			role: VariableRole.PARAM,
			unit: 'machine',
			defaultValue: 3,
			showInGui: false
		},
		{
			id: 'avarageDailyRevenue',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'totalBuildings',
			role: VariableRole.EXPRESSION,
			unit: 'building',
			defaultValue: 1,
			showInGui: true
		},
		{
			id: 'receivablesDelta',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'payablesDelta',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'workingDays',
			role: VariableRole.PARAM,
			unit: 'day',
			defaultValue: 365,
			showInGui: false
		},
		{
			id: 'outsourcingUnitCost',
			role: VariableRole.PARAM,
			unit: '€/juice',
			defaultValue: 1.9,
			showInGui: false
		},
		{
			id: 'qualityCheckInitialInvestment',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 500000,
			showInGui: false
		},
		{
			id: 'qualityCheckInvestmentPersonelUnit',
			role: VariableRole.PARAM,
			unit: '€/person',
			defaultValue: 250000,
			showInGui: false
		},
		{
			id: 'qualityCheckPersonelUnitCost',
			role: VariableRole.PARAM,
			unit: '€/person/machine',
			defaultValue: 50000,
			showInGui: false
		},
		{
			id: 'recyclingAndWasteManagementUnitCost',
			role: VariableRole.PARAM,
			unit: '€/machine',
			defaultValue: 100000,
			showInGui: false
		},
		{
			id: 'qualityMaintenanceUnitCost',
			role: VariableRole.PARAM,
			unit: '€/machine',
			defaultValue: 50000,
			showInGui: false
		},
		{
			id: 'juiceTasterUnitCost',
			role: VariableRole.PARAM,
			unit: '€/machine',
			defaultValue: 60000,
			showInGui: false
		},
		{
			id: 'chemicalExpertUnitCost',
			role: VariableRole.PARAM,
			unit: '€/building',
			defaultValue: 80000,
			showInGui: false
		},
		{
			id: 'recyclingAndWasteManagement',
			role: VariableRole.DECISION,
			unit: 'person',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'qualityMaintenance',
			role: VariableRole.DECISION,
			unit: 'person',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'juiceTaster',
			role: VariableRole.DECISION,
			unit: 'person',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'chemicalExpert',
			role: VariableRole.DECISION,
			unit: 'person',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'qualityCheckPersonelTotalCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'qualityCheckPersonelTotalInvestments',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'recyclingAndWasteManagementTotalCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'qualityMaintenanceTotalCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'juiceTasterTotalCost',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'chemicalExpertTotalCost',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'qualityTotalCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'qualityControlDepreciation',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'qualityControlOperatingCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'qualityControlCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'logisticUnitCosts',
			role: VariableRole.PARAM,
			unit: '€/machine',
			defaultValue: 150000,
			showInGui: false
		},
		{
			id: 'logisticCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'qualityCheckUnitCost',
			role: VariableRole.PARAM,
			unit: '€/juice',
			defaultValue: 1,
			showInGui: false
		},
		{
			id: 'buildingRentUnit',
			role: VariableRole.PARAM,
			unit: '€/Yr/building',
			defaultValue: 750000,
			showInGui: true
		},
		{
			id: 'buildingRentTotal',
			role: VariableRole.EXPRESSION,
			unit: '€/Yr',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'machineCost',
			role: VariableRole.PARAM,
			unit: '€/machine',
			defaultValue: 12500000,
			showInGui: true
		},
		{
			id: 'machinesTotalCost',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'logisticPersonelUnitCost',
			role: VariableRole.PARAM,
			unit: '€/machine',
			defaultValue: 150000,
			showInGui: false
		},
		{
			id: 'utilities',
			role: VariableRole.PARAM,
			unit: '€/machine',
			defaultValue: 500000,
			showInGui: false
		},
		{
			id: 'inventoryDelta',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'bomEmptyBottles',
			role: VariableRole.PARAM,
			unit: '[pz]/[pz]',
			defaultValue: 1,
			showInGui: true
		},
		{
			id: 'bomApples',
			role: VariableRole.PARAM,
			unit: '[pz]/[pz]',
			defaultValue: 0.85,
			showInGui: true
		},
		{
			id: 'outsourcingQuota',
			role: VariableRole.DECISION,
			unit: 'percentage',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'machineProductionCapacity',
			role: VariableRole.PARAM,
			unit: 'juice/year',
			defaultValue: 5400000,
			showInGui: true
		},
		{
			id: 'machineProductionCapacityUsageQuota',
			role: VariableRole.DECISION,
			unit: 'juice/year',
			defaultValue: 100,
			showInGui: true
		},
		{
			id: 'machineProductionCapacityUsage',
			role: VariableRole.EXPRESSION,
			unit: 'juice/year',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'totalProductionCapacityAtFullUsage',
			role: VariableRole.EXPRESSION,
			unit: 'juice/year',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'machines',
			role: VariableRole.DECISION,
			unit: 'machine',
			defaultValue: 1,
			showInGui: true
		},
		{
			id: 'buildingsSaturation',
			role: VariableRole.EXPRESSION,
			unit: '',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'outsourcedUnits',
			role: VariableRole.EXPRESSION,
			unit: 'Un',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'outsourcingDaysPayable',
			role: VariableRole.PARAM,
			unit: 'day',
			defaultValue: 60,
			showInGui: true
		},
		{
			id: 'internallyProducedUnits',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'producedUnits',
			role: VariableRole.EXPRESSION,
			unit: 'juice/year',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'PRDwh',
			role: VariableRole.EXPRESSION,
			unit: 'juice',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'beginningWhApples',
			role: VariableRole.EXPRESSION,
			unit: '[pz]',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'beginningWhBottles',
			role: VariableRole.EXPRESSION,
			unit: '[pz]',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'endingWhApples',
			role: VariableRole.EXPRESSION,
			unit: '[pz]',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'endingWhApplesOnProducedUnits',
			role: VariableRole.EXPRESSION,
			unit: '%',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'endingWhApplesOnPurchasedUnits',
			role: VariableRole.EXPRESSION,
			unit: '%',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'endingWhBottles',
			role: VariableRole.EXPRESSION,
			unit: '[pz]',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'endingWhBottlesOnProducedUnits',
			role: VariableRole.EXPRESSION,
			unit: '%',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'endingWhBottlesOnPurchasedUnits',
			role: VariableRole.EXPRESSION,
			unit: '%',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'beginningWhJuice',
			role: VariableRole.EXPRESSION,
			unit: 'u',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'neededJuice',
			role: VariableRole.EXPRESSION,
			unit: 'u',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'endingWhJuice',
			role: VariableRole.EXPRESSION,
			unit: 'u',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'endingWhJuiceOnProducedUnits',
			role: VariableRole.EXPRESSION,
			unit: '%',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'endingWhJuiceOnPurchasedUnits',
			role: VariableRole.EXPRESSION,
			unit: '%',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'supplier1MinimumLotBottles',
			role: VariableRole.PARAM,
			unit: '[pz]',
			defaultValue: 5000000,
			showInGui: false
		},
		{
			id: 'supplier2MinimumLotBottles',
			role: VariableRole.PARAM,
			unit: '[pz]',
			defaultValue: 5000000,
			showInGui: false
		},
		{
			id: 'supplier3MinimumLotBottles',
			role: VariableRole.PARAM,
			unit: '[pz]',
			defaultValue: 5000000,
			showInGui: false
		},
		{
			id: 'supplier1CostBottles',
			role: VariableRole.PARAM,
			unit: '€/[pz]',
			defaultValue: 0.3,
			showInGui: true
		},
		{
			id: 'supplier2CostBottles',
			role: VariableRole.PARAM,
			unit: '€/[pz]',
			defaultValue: 0.35,
			showInGui: true
		},
		{
			id: 'supplier3CostBottles',
			role: VariableRole.PARAM,
			unit: '€/[pz]',
			defaultValue: 0.5,
			showInGui: true
		},
		{
			id: 'supplier1daysInPayablesBottles',
			role: VariableRole.PARAM,
			unit: 'days',
			defaultValue: 10,
			showInGui: true
		},
		{
			id: 'supplier2daysInPayablesBottles',
			role: VariableRole.PARAM,
			unit: 'days',
			defaultValue: 10,
			showInGui: true
		},
		{
			id: 'supplier3daysInPayablesBottles',
			role: VariableRole.PARAM,
			unit: 'days',
			defaultValue: 10,
			showInGui: true
		},
		{
			id: 'supplier1MinimumLotApples',
			role: VariableRole.PARAM,
			unit: '[pz]',
			defaultValue: 4000000,
			showInGui: true
		},
		{
			id: 'supplier2MinimumLotApples',
			role: VariableRole.PARAM,
			unit: '[pz]',
			defaultValue: 6000000,
			showInGui: true
		},
		{
			id: 'supplier3MinimumLotApples',
			role: VariableRole.PARAM,
			unit: '[pz]',
			defaultValue: 8000000,
			showInGui: true
		},
		{
			id: 'supplier1CostApples',
			role: VariableRole.PARAM,
			unit: '€/[kg]',
			defaultValue: 0.94,
			showInGui: true
		},
		{
			id: 'supplier2CostApples',
			role: VariableRole.PARAM,
			unit: '€/[kg]',
			defaultValue: 1.06,
			showInGui: true
		},
		{
			id: 'supplier3CostApples',
			role: VariableRole.PARAM,
			unit: '€/[kg]',
			defaultValue: 1.25,
			showInGui: true
		},
		{
			id: 'supplier1daysInPayablesApples',
			role: VariableRole.PARAM,
			unit: 'days',
			defaultValue: 20,
			showInGui: true
		},
		{
			id: 'supplier2daysInPayablesApples',
			role: VariableRole.PARAM,
			unit: 'days',
			defaultValue: 35,
			showInGui: true
		},
		{
			id: 'supplier3daysInPayablesApples',
			role: VariableRole.PARAM,
			unit: 'days',
			defaultValue: 50,
			showInGui: true
		},
		{
			id: 'supplyNeedsBottles',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'soldBottles',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'outsourcedBottles',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'supplyNeedsApples',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'soldApples',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'outsourcedApples',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'supplierOrderBottles',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'supplierOrderApples',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'longInterestRateA',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 0.035,
			showInGui: false
		},
		{
			id: 'longInterestRateB',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 0.04,
			showInGui: false
		},
		{
			id: 'longInterestRateC',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 0.05,
			showInGui: false
		},
		{
			id: 'longInterestRateTerm',
			role: VariableRole.PARAM,
			unit: '',
			defaultValue: 0.06,
			showInGui: false
		},
		{
			id: 'supplierAppleChoice',
			role: VariableRole.DECISION,
			unit: '',
			defaultValue: 1,
			showInGui: true
		},
		{
			id: 'supplierBottleChoice',
			role: VariableRole.PARAM,
			unit: '',
			defaultValue: 1,
			showInGui: true
		},
		{
			id: 'qualityCheckPersonelDepreciation',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: true
		},
		{
			id: 'finishedGoodsUnitaryCosts',
			role: VariableRole.EXPRESSION,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		{
			id: 'people',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 1,
			showInGui: false
		},
		{
			id: 'externallyProducedUnits',
			role: VariableRole.PARAM,
			unit: '€',
			defaultValue: 0,
			showInGui: false
		},
		...builtinArgs.reduce( ( acc, arg ) => {
			acc.push({
				...arg,
				role: VariableRole.PARAM,
				unit: '',
				showInGui: false
			});
			return acc;
		}, [])
	],
	params: {

		//args year 1
		'supplierPerformance1:1' : 0.15,
		'supplierPerformance2:1' : 0.4,
		'supplierPerformance3:1' : 1,
		'supplierBottlePerformance1:1' : 0.3,
		'supplierBottlePerformance2:1' : 0.6,
		'supplierBottlePerformance3:1' : 1,
		'qualityCheckPerformance1:1' : 0.2,
		'qualityCheckPerformance2:1' : 0.45,
		'qualityCheckPerformance3:1' : 0.7,
		'qualityCheckPerformance4:1' : 1,
		'marketingBudgetPerformance_range1_min:1' : 0,
		'marketingBudgetPerformance_range1_max:1' : Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range1_const1:1' : Math.pow( 10, -7 ),
		'marketingBudgetPerformance_range2_min:1' : Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range2_max:1' : 4 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range2_const1:1' : 1.33 * Math.pow( 10, -7 ),
		'marketingBudgetPerformance_range2_const2:1' : -0.033,
		'marketingBudgetPerformance_range3_min:1' : 4 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range3_max:1' : 6 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range3_const1:1' : Math.pow( 10, -7 ),
		'marketingBudgetPerformance_range3_const2:1' : 0.1,
		'marketingBudgetPerformance_range4_min:1' : 6 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range4_max:1' : 8 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range4_const1:1' : 7.5 * Math.pow( 10, -8 ),
		'marketingBudgetPerformance_range4_const2:1' : 0.25,
		'marketingBudgetPerformance_range5_min:1' : 8 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range5_max:1' : 9.8 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range5_const1:1' : 8.33 * Math.pow( 10, -8 ),
		'marketingBudgetPerformance_range5_const2:1' : 0.183,
		'marketingBudgetPerformance_range6_min:1' : 9.8 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range6_const1:1' : 1,
		'capitalExpenditures_range1_min:1' : 120000000,
		'capitalExpenditures_range1_const1:1' : 80000000,
		'capitalExpenditures_range2_min:1' : 30000000,
		'capitalExpenditures_range2_max:1' : 75000000,
		'capitalExpenditures_range2_const1:1' : 30000000,
		'capitalExpenditures_range3_min:1' : 30000000,
		'capitalExpenditures_range4_const1:1' : 50000000,
		'pricePerformance_range1_min:1' : 0,
		'pricePerformance_range1_max:1' : 1,
		'pricePerformance_range1_const1:1' : -0.6,
		'pricePerformance_range1_const2:1' : 0.8,
		'pricePerformance_range2_min:1' : 1,
		'pricePerformance_range2_max:1' : 2.2,
		'pricePerformance_range2_const1:1' : -( 5 / 9 ),
		'pricePerformance_range2_const2:1' : 2,
		'pricePerformance_range2_const3:1' : ( 22 / 9 ),
		'pricePerformance_range2_const4:1' : -( 76 / 45 ),
		'pricePerformance_range3_min:1' : 2.2,
		'pricePerformance_range3_max:1' : 2.4,
		'pricePerformance_range3_const1:1' : 1,
		'pricePerformance_range4_min:1' : 2.4,
		'pricePerformance_range4_max:1' : 4,
		'pricePerformance_range4_const1:1' : 58,
		'pricePerformance_range4_const2:1' : 200,
		'pricePerformance_range4_const3:1' : -422,
		'pricePerformance_range5_min:1' : 4,
		'pricePerformance_range5_max:1' : 4.5,
		'pricePerformance_range5_const1:1' : -0.2376,
		'pricePerformance_range5_const2:1' : 1.0692,
		'pricePerformance_range6_min:1' : 4.5,
		'pricePerformance_range6_const1:1' : 0,
		'marketingPerformance_const1:1' : 0.4,
		'marketingPerformance_const2:1' : 0.6,
		'daysReceivablePerformance_range1_max:1' : 20,
		'daysReceivablePerformance_range1_const1:1' : 0,
		'daysReceivablePerformance_range2_min:1' : 20,
		'daysReceivablePerformance_range2_max:1' : 30,
		'daysReceivablePerformance_range2_const1:1' : 0.03,
		'daysReceivablePerformance_range2_const2:1' : -0.6,
		'daysReceivablePerformance_range3_min:1' : 30,
		'daysReceivablePerformance_range3_max:1' : 35,
		'daysReceivablePerformance_range3_const1:1' : 0.04,
		'daysReceivablePerformance_range3_const2:1' : -0.9,
		'daysReceivablePerformance_range4_min:1' : 35,
		'daysReceivablePerformance_range4_max:1' : 45,
		'daysReceivablePerformance_range4_const1:1' : 0.03,
		'daysReceivablePerformance_range4_const2:1' : -0.55,
		'daysReceivablePerformance_range5_min:1' : 45,
		'daysReceivablePerformance_range5_const1:1' : 1,
		'marketingImportance_const1:1' : 1,
		'marketingImportance_const2:1' : -4.5,
		'marketingImportance_const3:1' : -0.1,
		'demandQuota_const1:1' : 0.072135,
		'demandQuota_const2:1' : 1,
		'demandQuota_const3:1' : 0.05,
		'qualityPerformance_const1:1' : 0.65,
		'qualityPerformance_const2:1' : 0.21,
		'qualityPerformance_const3:1' : 0.07,
		'qualityPerformance_const4:1' : 0.04,
		'qualityPerformance_const5:1' : 0.03,
		'qualityPerformance_const6:1' : 0,
		'qualityImportance_const1:1' : 4.5,
		'normalizeSupposedQualityPerformance_const1:1' : 5,
		'shortTermDebtFormula_const1:1' : 1,
		'shortTermDebtFormula_const2:1' : 0.05,

		//args year 2
		'supplierPerformance1:2' : 0.15,
		'supplierPerformance2:2' : 0.4,
		'supplierPerformance3:2' : 1,
		'supplierBottlePerformance1:2' : 0.3,
		'supplierBottlePerformance2:2' : 0.6,
		'supplierBottlePerformance3:2' : 1,
		'qualityCheckPerformance1:2' : 0.18,
		'qualityCheckPerformance2:2' : 0.42,
		'qualityCheckPerformance3:2' : 0.65,
		'qualityCheckPerformance4:2' : 1,
		'marketingBudgetPerformance_range1_min:2' : 0,
		'marketingBudgetPerformance_range1_max:2' : Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range1_const1:2' : Math.pow( 10, -7 ),
		'marketingBudgetPerformance_range2_min:2' : Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range2_max:2' : 4 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range2_const1:2' : 1.33 * Math.pow( 10, -7 ),
		'marketingBudgetPerformance_range2_const2:2' : -0.033,
		'marketingBudgetPerformance_range3_min:2' : 4 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range3_max:2' : 6 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range3_const1:2' : Math.pow( 10, -7 ),
		'marketingBudgetPerformance_range3_const2:2' : 0.1,
		'marketingBudgetPerformance_range4_min:2' : 6 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range4_max:2' : 8 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range4_const1:2' : 7.5 * Math.pow( 10, -8 ),
		'marketingBudgetPerformance_range4_const2:2' : 0.25,
		'marketingBudgetPerformance_range5_min:2' : 8 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range5_max:2' : 9.8 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range5_const1:2' : 8.33 * Math.pow( 10, -8 ),
		'marketingBudgetPerformance_range5_const2:2' : 0.183,
		'marketingBudgetPerformance_range6_min:2' : 9.8 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range6_const1:2' : 1,
		'capitalExpenditures_range1_min:2' : 120000000,
		'capitalExpenditures_range1_const1:2' : 80000000,
		'capitalExpenditures_range2_min:2' : 30000000,
		'capitalExpenditures_range2_max:2' : 75000000,
		'capitalExpenditures_range2_const1:2' : 30000000,
		'capitalExpenditures_range3_min:2' : 30000000,
		'capitalExpenditures_range4_const1:2' : 50000000,
		'pricePerformance_range1_min:2' : 0,
		'pricePerformance_range1_max:2' : 1,
		'pricePerformance_range1_const1:2' : -0.6,
		'pricePerformance_range1_const2:2' : 0.8,
		'pricePerformance_range2_min:2' : 1,
		'pricePerformance_range2_max:2' : 2.2,
		'pricePerformance_range2_const1:2' : -(5/9),
		'pricePerformance_range2_const2:2' : 2,
		'pricePerformance_range2_const3:2' : (22/9),
		'pricePerformance_range2_const4:2' : -(76/45),
		'pricePerformance_range3_min:2' : 2.2,
		'pricePerformance_range3_max:2' : 2.4,
		'pricePerformance_range3_const1:2' : 1,
		'pricePerformance_range4_min:2' : 2.4,
		'pricePerformance_range4_max:2' : 4,
		'pricePerformance_range4_const1:2' : 62.4,
		'pricePerformance_range4_const2:2' : 176,
		'pricePerformance_range4_const3:2' : -360,
		'pricePerformance_range5_min:2' : 4,
		'pricePerformance_range5_max:2' : 4.5,
		'pricePerformance_range5_const1:2' : -0.2376,
		'pricePerformance_range5_const2:2' : 1.0692,
		'pricePerformance_range6_min:2' : 4.5,
		'pricePerformance_range6_const1:2' : 0,
		'marketingPerformance_const1:2' : 0.4,
		'marketingPerformance_const2:2' : 0.6,
		'daysReceivablePerformance_range1_max:2' : 20,
		'daysReceivablePerformance_range1_const1:2' : 0,
		'daysReceivablePerformance_range2_min:2' : 20,
		'daysReceivablePerformance_range2_max:2' : 30,
		'daysReceivablePerformance_range2_const1:2' : 0.03,
		'daysReceivablePerformance_range2_const2:2' : -0.6,
		'daysReceivablePerformance_range3_min:2' : 30,
		'daysReceivablePerformance_range3_max:2' : 35,
		'daysReceivablePerformance_range3_const1:2' : 0.04,
		'daysReceivablePerformance_range3_const2:2' : -0.9,
		'daysReceivablePerformance_range4_min:2' : 35,
		'daysReceivablePerformance_range4_max:2' : 45,
		'daysReceivablePerformance_range4_const1:2' : 0.03,
		'daysReceivablePerformance_range4_const2:2' : -0.55,
		'daysReceivablePerformance_range5_min:2' : 45,
		'daysReceivablePerformance_range5_const1:2' : 1,
		'marketingImportance_const1:2' : 1,
		'marketingImportance_const2:2' : -4.6,
		'marketingImportance_const3:2' : -0.1,
		'demandQuota_const1:2' : 0.072135,
		'demandQuota_const2:2' : 1,
		'demandQuota_const3:2' : 0.05,
		'qualityPerformance_const1:2' : 0.60,
		'qualityPerformance_const2:2' : 0.23,
		'qualityPerformance_const3:2' : 0.07,
		'qualityPerformance_const4:2' : 0.05,
		'qualityPerformance_const5:2' : 0.05,
		'qualityPerformance_const6:2' : 0,
		'qualityImportance_const1:2' : 4.6,
		'normalizeSupposedQualityPerformance_const1:2' : 5,
		'shortTermDebtFormula_const1:2' : 1,
		'shortTermDebtFormula_const2:2' : 0.05,

		//args year 3
		'supplierPerformance1:3' : 0.15,
		'supplierPerformance2:3' : 0.4,
		'supplierPerformance3:3' : 1,
		'supplierBottlePerformance1:3' : 0.3,
		'supplierBottlePerformance2:3' : 0.6,
		'supplierBottlePerformance3:3' : 1,
		'qualityCheckPerformance1:3' : 0.15,
		'qualityCheckPerformance2:3' : 0.38,
		'qualityCheckPerformance3:3' : 0.62,
		'qualityCheckPerformance4:3' : 1,
		'marketingBudgetPerformance_range1_min:3' : 0,
		'marketingBudgetPerformance_range1_max:3' : 5 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range1_const1:3' : Math.pow( 10, -7 ),
		'marketingBudgetPerformance_range2_min:3' : 5 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range2_max:3' : 9 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range2_const1:3' : 8.75 * Math.pow( 10, -8 ),
		'marketingBudgetPerformance_range2_const2:3' : 0.0625,
		'marketingBudgetPerformance_range3_min:3' : 9 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range3_max:3' : 10.5 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range3_const1:3' : Math.pow( 10, -7 ),
		'marketingBudgetPerformance_range3_const2:3' : -0.05,
		'marketingBudgetPerformance_range4_min:3' : 9 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range4_max:3' : 10.5 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range4_const1:3' : 0,
		'marketingBudgetPerformance_range4_const2:3' : 0,
		'marketingBudgetPerformance_range5_min:3' : 9 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range5_max:3' : 10.5 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range5_const1:3' : 0,
		'marketingBudgetPerformance_range5_const2:3' : 0,
		'marketingBudgetPerformance_range6_min:3' : 10.5 * Math.pow( 10, 6 ),
		'marketingBudgetPerformance_range6_const1:3' : 1,
		'capitalExpenditures_range1_min:3' : 120000000,
		'capitalExpenditures_range1_const1:3' : 80000000,
		'capitalExpenditures_range2_min:3' : 30000000,
		'capitalExpenditures_range2_max:3' : 75000000,
		'capitalExpenditures_range2_const1:3' : 30000000,
		'capitalExpenditures_range3_min:3' : 30000000,
		'capitalExpenditures_range4_const1:3' : 50000000,
		'pricePerformance_range1_min:3' : 0,
		'pricePerformance_range1_max:3' : 1,
		'pricePerformance_range1_const1:3' : -0.6,
		'pricePerformance_range1_const2:3' : 0.8,
		'pricePerformance_range2_min:3' : 1,
		'pricePerformance_range2_max:3' : 2.2,
		'pricePerformance_range2_const1:3' : -(5/9),
		'pricePerformance_range2_const2:3' : 2,
		'pricePerformance_range2_const3:3' : (22/9),
		'pricePerformance_range2_const4:3' : -(76/45),
		'pricePerformance_range3_min:3' : 2.2,
		'pricePerformance_range3_max:3' : 2.4,
		'pricePerformance_range3_const1:3' : 1,
		'pricePerformance_range4_min:3' : 2.4,
		'pricePerformance_range4_max:3' : 4,
		'pricePerformance_range4_const1:3' : 70,
		'pricePerformance_range4_const2:3' : 143.37,
		'pricePerformance_range4_const3:3' : -274.1,
		'pricePerformance_range5_min:3' : 4,
		'pricePerformance_range5_max:3' : 4.5,
		'pricePerformance_range5_const1:3' : -0.2376,
		'pricePerformance_range5_const2:3' : 1.0692,
		'pricePerformance_range6_min:3' : 4.5,
		'pricePerformance_range6_const1:3' : 0,
		'marketingPerformance_const1:3' : 0.4,
		'marketingPerformance_const2:3' : 0.6,
		'daysReceivablePerformance_range1_max:3' : 20,
		'daysReceivablePerformance_range1_const1:3' : 0,
		'daysReceivablePerformance_range2_min:3' : 20,
		'daysReceivablePerformance_range2_max:3' : 30,
		'daysReceivablePerformance_range2_const1:3' : 0.03,
		'daysReceivablePerformance_range2_const2:3' : -0.6,
		'daysReceivablePerformance_range3_min:3' : 30,
		'daysReceivablePerformance_range3_max:3' : 35,
		'daysReceivablePerformance_range3_const1:3' : 0.04,
		'daysReceivablePerformance_range3_const2:3' : -0.9,
		'daysReceivablePerformance_range4_min:3' : 35,
		'daysReceivablePerformance_range4_max:3' : 45,
		'daysReceivablePerformance_range4_const1:3' : 0.03,
		'daysReceivablePerformance_range4_const2:3' : -0.55,
		'daysReceivablePerformance_range5_min:3' : 45,
		'daysReceivablePerformance_range5_const1:3' : 1,
		'marketingImportance_const1:3' : 1,
		'marketingImportance_const2:3' : -4.7,
		'marketingImportance_const3:3' : -0.1,
		'demandQuota_const1:3' : 0.072135,
		'demandQuota_const2:3' : 1,
		'demandQuota_const3:3' : 0.05,
		'qualityPerformance_const1:3' : 0.57,
		'qualityPerformance_const2:3' : 0.24,
		'qualityPerformance_const3:3' : 0.07,
		'qualityPerformance_const4:3' : 0.06,
		'qualityPerformance_const5:3' : 0.06,
		'qualityPerformance_const6:3' : 0,
		'qualityImportance_const1:3' : 4.7,
		'normalizeSupposedQualityPerformance_const1:3' : 5,
		'shortTermDebtFormula_const1:3' : 1,
		'shortTermDebtFormula_const2:3' : 0.05,

		//esempio parametri
		'longInterestRateTerm:0' : 0,
		'longInterestRateTerm:1' : 0,
		'longInterestRateTerm:2' : 0,
		'longInterestRateTerm:3' : 0,

	}
}
